import { forwardRef, useContext, useEffect } from "react"
import { mutate } from "swr"

import InputWithUnit from "./InputWithUnit/InputWithUnit"
import { LocalizationContext } from "web/contexts"
import { useUnits } from "web/hooks/data"

const MoneyInput = forwardRef((props, ref) => {
  const { defaultCurrency } = useContext(LocalizationContext)
  const [{ currencies }] = useUnits()
  const supportedCurrencyCodes = currencies.map((c) => c.code)

  useEffect(() => {
    if (!supportedCurrencyCodes.includes(defaultCurrency)) {
      mutate("/currencies")
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <InputWithUnit
      ref={ref}
      kind="Money"
      units={supportedCurrencyCodes}
      defaultUnit={defaultCurrency}
      {...props}
    />
  )
})

export default MoneyInput
